import { useEffect } from "react";

const PhytosociologicalDbPage = () => {
  useEffect(() => {
    window.location.replace("https://czechveg.github.io/");
  }, []);

  return null;
};

export default PhytosociologicalDbPage;